import { render } from "./LineRedemptionBox.vue?vue&type=template&id=71fe887c"
import script from "./LineRedemptionBox.vue?vue&type=script&lang=js"
export * from "./LineRedemptionBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__